import styled from 'styled-components'
import { IconV2 } from 'ui/components/Icon'

export const WrappedIcon = styled(IconV2)`
  margin-right: 22px;

  svg {
    color: ${(p) => p.theme.uiKit.colors.global.general.main};
  }
`

export const WrappedIconGreen = styled(WrappedIcon)`
  svg {
    color: ${(p) => p.theme.uiKit.colors.theme.brand.primary};
  }
`

export const SmallToastIcon = styled(IconV2)`
  display: flex;
`

export const IconInfo = styled(IconV2)`
  color: var(--theme-colors-theme-brand-primary);
`

export const IconSuccess = styled(IconV2)`
  color: var(--theme-colors-theme-brand-primary);
`

export const IconError = styled(IconV2)`
  color: var(--theme-colors-theme-negative-main);
`

export const SmallToastIconGreen = styled(SmallToastIcon)`
  svg {
    color: ${(p) => p.theme.uiKit.colors.theme.brand.primary};
  }
`

export const SmallToastContent = styled.div.attrs({
  'data-qa': 'feedback-toast'
})`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const BigToastContent = styled.div.attrs({
  'data-qa': 'feedback-toast'
})`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Title = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font: var(--theme-typography-h5-regular);
`

export const Content = styled.div`
  font: var(--theme-typography-bodyM-regular);
  max-width: 326px;
`

export const Button = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  border: none;
  background-color: transparent;
  padding: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: var(--theme-colors-global-grey-grey500);
`
